import { render, staticRenderFns } from "./RefundHeader.vue?vue&type=template&id=0dad881d&scoped=true"
import script from "./RefundHeader.vue?vue&type=script&lang=js"
export * from "./RefundHeader.vue?vue&type=script&lang=js"
import style0 from "./RefundHeader.vue?vue&type=style&index=0&id=0dad881d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dad881d",
  null
  
)

export default component.exports